import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import { orgProfile, roles } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

function SettingsPage(props: BusinessPageProps) {
  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '系统设置', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="settings"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader heading="系统设置" sub="EXCEL HR 系统级配置(只读)" />

      <SectionCard title="组织信息" description="公司基本信息">
        <ul className="axi-settings-list">
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">公司名称</span>
            <span className="axi-settings-list__value">{orgProfile.companyName}</span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">简称</span>
            <span className="axi-settings-list__value">{orgProfile.shortName}</span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">域名</span>
            <span className="axi-settings-list__value">{orgProfile.domain}</span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">成立年份</span>
            <span className="axi-settings-list__value">{orgProfile.foundedYear}</span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">品牌标识</span>
            <span className="axi-settings-list__value" aria-label="品牌标识">
              <span className="axi-tag" aria-hidden="true">{orgProfile.logoMark}</span>
            </span>
          </li>
        </ul>
      </SectionCard>

      <SectionCard title="权限角色" description="RBAC 角色与权限标签">
        {roles.map((role) => (
          <div key={role.id}>
            <h3 className="axi-section-card__heading" style={{ marginBottom: 4 }}>
              {role.label}
            </h3>
            <p className="axi-section-card__description" style={{ marginBottom: 6 }}>
              {role.description}
            </p>
            <div>
              {role.permissions.map((perm) => (
                <span key={perm} className="axi-tag">{perm}</span>
              ))}
            </div>
          </div>
        ))}
      </SectionCard>

      <SectionCard title="通知设置" description="开关占位,实际生效需要后端接口">
        <ul className="axi-settings-list">
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">邮件通知</span>
            <span className="axi-switch is-on is-disabled" aria-disabled="true">
              <span className="axi-switch__track" aria-hidden="true">
                <span className="axi-switch__thumb" />
              </span>
              <span>已开启(占位)</span>
            </span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">站内消息</span>
            <span className="axi-switch is-on is-disabled" aria-disabled="true">
              <span className="axi-switch__track" aria-hidden="true">
                <span className="axi-switch__thumb" />
              </span>
              <span>已开启(占位)</span>
            </span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">钉钉机器人</span>
            <span className="axi-switch is-disabled" aria-disabled="true">
              <span className="axi-switch__track" aria-hidden="true">
                <span className="axi-switch__thumb" />
              </span>
              <span>未开启(占位)</span>
            </span>
          </li>
        </ul>
      </SectionCard>

      <SectionCard title="主题外观" description="主题由 dark-gold 插件提供,通过顶部齿轮切换">
        <ul className="axi-settings-list">
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">当前主题</span>
            <span className="axi-settings-list__value">dark-gold</span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">主题存储</span>
            <span className="axi-settings-list__value">localStorage[axi.theme]</span>
          </li>
          <li className="axi-settings-list__row">
            <span className="axi-settings-list__label">设计令牌</span>
            <span className="axi-settings-list__value">@axi/tokens</span>
          </li>
        </ul>
      </SectionCard>
    </DashboardLayout>
  );
}

export default SettingsPage;